"use client";

import { useAppearance } from "@/hooks/use-appearance";
import { useTranslation } from "react-i18next";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
} from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { appearance } = useAppearance();
  const { t } = useTranslation();

  return (
    <Sonner
      theme={appearance}
      className="toaster group z-40!"
      position="top-right"
      closeButton
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          fontFamily: "var(--font-sans)",
          "--success-bg": "var(--success-surface)",
          "--success-text": "var(--success)",
          "--success-border": "var(--success)",
          "--info-bg": "var(--info-surface)",
          "--info-text": "var(--info)",
          "--info-border": "var(--info)",
          "--warning-bg": "var(--warning-surface)",
          "--warning-text": "var(--warning)",
          "--warning-border": "var(--warning)",
          "--error-bg": "var(--destructive-soft)",
          "--error-text": "var(--destructive)",
          "--error-border": "var(--destructive)",
        } as React.CSSProperties
      }
      toastOptions={{
        closeButtonAriaLabel: t("common.close"),
        style: {
          boxShadow: "var(--elevation-popover)",
          fontSize: "var(--text-sm)",
        },
        classNames: {
          closeButton: "min-h-6! min-w-6!",
          toast:
            "cn-toast data-[removed=true]:pointer-events-none! focus-visible:outline-2! focus-visible:outline-offset-2! focus-visible:outline-ring!",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
